/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyProfileUpdate
 */
export interface ProxyProfileUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    proxyGenerator?: ProxyProfileUpdateProxyGeneratorEnum;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    type?: ProxyProfileUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    resolution?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    rateControl?: ProxyProfileUpdateRateControlEnum;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    crf?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    bitrate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    audioBitrate?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    variantsLimit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyProfileUpdate
     */
    enableDenseFilmstrip?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyProfileUpdate
     */
    enableWatermark?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    watermarkImage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    watermarkPosition?: ProxyProfileUpdateWatermarkPositionEnum;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    watermarkOpacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    watermarkSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyProfileUpdate
     */
    enableTimecode?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    timecodePosition?: ProxyProfileUpdateTimecodePositionEnum;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    timecodeOpacity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    timecodeSize?: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    lut?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    hotfolderCopyTo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    hotfolderReadFrom?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    hotfolderQueueTimeout?: number;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    hotfolderEncodeTimeout?: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    vantageWorkflowId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyProfileUpdate
     */
    externalTranscoderStagingPath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProxyProfileUpdate
     */
    externalTranscoder?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum ProxyProfileUpdateProxyGeneratorEnum {
    Ffmpeg = 'ffmpeg',
    Hotfolder = 'hotfolder',
    Transkoder = 'transkoder',
    Vantage = 'vantage',
    Noop = 'noop'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileUpdateTypeEnum {
    Video = 'video',
    Audio = 'audio',
    Image = 'image',
    Pdf = 'pdf',
    Office = 'office',
    Model = 'model',
    Subtitle = 'subtitle',
    Fcpxml = 'fcpxml',
    Fcpxxml = 'fcpxxml',
    Prproj = 'prproj',
    Aep = 'aep',
    Avp = 'avp'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileUpdateRateControlEnum {
    Crf = 'CRF',
    Cbr = 'CBR',
    Vbr = 'VBR'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileUpdateWatermarkPositionEnum {
    Tl = 'TL',
    Tr = 'TR',
    Br = 'BR',
    Bl = 'BL',
    C = 'C'
}/**
* @export
* @enum {string}
*/
export enum ProxyProfileUpdateTimecodePositionEnum {
    Tl = 'TL',
    Tr = 'TR',
    Br = 'BR',
    Bl = 'BL',
    C = 'C'
}

export function ProxyProfileUpdateFromJSON(json: any): ProxyProfileUpdate {
    return ProxyProfileUpdateFromJSONTyped(json, false);
}

export function ProxyProfileUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyProfileUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'proxyGenerator': !exists(json, 'proxy_generator') ? undefined : json['proxy_generator'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'resolution': !exists(json, 'resolution') ? undefined : json['resolution'],
        'rateControl': !exists(json, 'rate_control') ? undefined : json['rate_control'],
        'crf': !exists(json, 'crf') ? undefined : json['crf'],
        'bitrate': !exists(json, 'bitrate') ? undefined : json['bitrate'],
        'audioBitrate': !exists(json, 'audio_bitrate') ? undefined : json['audio_bitrate'],
        'variantsLimit': !exists(json, 'variants_limit') ? undefined : json['variants_limit'],
        'enableDenseFilmstrip': !exists(json, 'enable_dense_filmstrip') ? undefined : json['enable_dense_filmstrip'],
        'enableWatermark': !exists(json, 'enable_watermark') ? undefined : json['enable_watermark'],
        'watermarkImage': !exists(json, 'watermark_image') ? undefined : json['watermark_image'],
        'watermarkPosition': !exists(json, 'watermark_position') ? undefined : json['watermark_position'],
        'watermarkOpacity': !exists(json, 'watermark_opacity') ? undefined : json['watermark_opacity'],
        'watermarkSize': !exists(json, 'watermark_size') ? undefined : json['watermark_size'],
        'enableTimecode': !exists(json, 'enable_timecode') ? undefined : json['enable_timecode'],
        'timecodePosition': !exists(json, 'timecode_position') ? undefined : json['timecode_position'],
        'timecodeOpacity': !exists(json, 'timecode_opacity') ? undefined : json['timecode_opacity'],
        'timecodeSize': !exists(json, 'timecode_size') ? undefined : json['timecode_size'],
        'lut': !exists(json, 'lut') ? undefined : json['lut'],
        'hotfolderCopyTo': !exists(json, 'hotfolder_copy_to') ? undefined : json['hotfolder_copy_to'],
        'hotfolderReadFrom': !exists(json, 'hotfolder_read_from') ? undefined : json['hotfolder_read_from'],
        'hotfolderQueueTimeout': !exists(json, 'hotfolder_queue_timeout') ? undefined : json['hotfolder_queue_timeout'],
        'hotfolderEncodeTimeout': !exists(json, 'hotfolder_encode_timeout') ? undefined : json['hotfolder_encode_timeout'],
        'vantageWorkflowId': !exists(json, 'vantage_workflow_id') ? undefined : json['vantage_workflow_id'],
        'externalTranscoderStagingPath': !exists(json, 'external_transcoder_staging_path') ? undefined : json['external_transcoder_staging_path'],
        'externalTranscoder': !exists(json, 'external_transcoder') ? undefined : json['external_transcoder'],
    };
}

export function ProxyProfileUpdateToJSON(value?: ProxyProfileUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'proxy_generator': value.proxyGenerator,
        'type': value.type,
        'resolution': value.resolution,
        'rate_control': value.rateControl,
        'crf': value.crf,
        'bitrate': value.bitrate,
        'audio_bitrate': value.audioBitrate,
        'variants_limit': value.variantsLimit,
        'enable_dense_filmstrip': value.enableDenseFilmstrip,
        'enable_watermark': value.enableWatermark,
        'watermark_image': value.watermarkImage,
        'watermark_position': value.watermarkPosition,
        'watermark_opacity': value.watermarkOpacity,
        'watermark_size': value.watermarkSize,
        'enable_timecode': value.enableTimecode,
        'timecode_position': value.timecodePosition,
        'timecode_opacity': value.timecodeOpacity,
        'timecode_size': value.timecodeSize,
        'lut': value.lut,
        'hotfolder_copy_to': value.hotfolderCopyTo,
        'hotfolder_read_from': value.hotfolderReadFrom,
        'hotfolder_queue_timeout': value.hotfolderQueueTimeout,
        'hotfolder_encode_timeout': value.hotfolderEncodeTimeout,
        'vantage_workflow_id': value.vantageWorkflowId,
        'external_transcoder_staging_path': value.externalTranscoderStagingPath,
        'external_transcoder': value.externalTranscoder,
    };
}


